import { createRoot } from 'react-dom/client';
import App from './App';
import "bootstrap/dist/css/bootstrap.css";

createRoot(document.getElementById('root')).render(<App />);
